import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Will a remap void my warranty or damage my engine?",
    a: "Our Stage 1 calibrations stay within the mechanical tolerances the manufacturer designed the engine for. We data-log before and after every tune, and every map carries a 12-month software warranty. Main-dealer warranty terms vary — we are happy to talk through your specific situation before booking.",
  },
  {
    q: "How long does a remap take?",
    a: "A Stage 1 remap typically takes 2–3 hours including diagnostics, the flash itself and road testing. Stage 2 and above, with a dyno session, usually takes half a day.",
  },
  {
    q: "Can the remap be reversed?",
    a: "Yes. We always back up your original factory file before touching anything. Your car can be returned to 100% stock at any time, free of charge.",
  },
  {
    q: "Will my fuel economy get worse?",
    a: "Driven the same way, most remapped diesels and turbo petrols actually improve economy by 5–12% thanks to stronger low-end torque. Drive it like you stole it and, well — that is on you.",
  },
  {
    q: "Do I need any hardware upgrades for Stage 1?",
    a: "No. Stage 1 is purely software and works on completely standard hardware. Stage 2 requires a downpipe and intake; we will advise exactly what your specific model needs.",
  },
];

export const Faq = () => (
  <section id="faq" className="relative py-24 sm:py-32 border-t border-[#1F232D] carbon-grid">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-12"
      >
        <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-nitro mb-4 flex items-center gap-3">
          <span className="inline-block w-10 h-px bg-nitro" />
          Straight Answers
        </p>
        <h2 className="font-heading font-bold uppercase text-4xl sm:text-5xl leading-[0.95] text-neutral-100">
          Before you <span className="text-nitro">ask</span>
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
      >
        <Accordion type="single" collapsible data-testid="faq-accordion" className="flex flex-col gap-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="glass-panel rounded-xl border border-[#262933] px-6 data-[state=open]:border-nitro/50 transition-colors duration-300"
            >
              <AccordionTrigger className="font-heading font-semibold uppercase tracking-wide text-left text-lg text-neutral-100 hover:text-nitro hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-neutral-400 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
